import Head from 'next/head'
import { useRouter } from 'next/router'
import qs from 'qs'

import ErrorContextProvider from 'errors/components/ErrorContextProvider'
import { getLocalePath, serverSideConfigs, t } from 'localization'
import LoginPanel from 'login/components/LoginPanel'
import getUser, { User } from 'server/utils/auth/getUser'
import PanelPageLayout from 'shared/components/Panel/PanelPageLayout'
import { FCGetServerSidePropsContext, getServerPageProps } from 'shared/utils/getServerSideProps'
import { parseCookies } from 'shared/utils/server-utils'

const TP = 'pages.customer.account.login'

const LoginPage = () => {
  const router = useRouter()
  const redirectUrl = qs.parse(router.asPath?.split('?')[1])

  return (
    <ErrorContextProvider>
      <Head>
        <title>{t(`${TP}.pageTitle`, 'Customer Login | Flight Club')}</title>
      </Head>
      <PanelPageLayout>
        <LoginPanel redirectUrl={redirectUrl} />
      </PanelPageLayout>
    </ErrorContextProvider>
  )
}

export const getServerSideProps = async (context: FCGetServerSidePropsContext) => {
  const { res, req, query, locale } = context
  const { jwt } = parseCookies(req)
  const { redirectTo: queryRedirectTo } = query
  const redirectTo = Array.isArray(queryRedirectTo) ? queryRedirectTo[0] : queryRedirectTo

  const user = getUser(jwt) as User
  const isAuthenticatedUser = user?.username

  return isAuthenticatedUser
    ? {
        props: {
          ...(await getServerPageProps(context)),
          ...(await serverSideConfigs(res, locale)),
        },
        redirect: {
          destination: getLocalePath(redirectTo || '/', locale),
          permanent: false,
        },
      }
    : {
        props: {
          ...(await getServerPageProps(context)),
          ...(await serverSideConfigs(res, locale)),
          redirectUrl: query,
        },
      }
}

export default LoginPage
